<template>
  <div>
    <header class="app-header">
      <a :href="redirect" class="header-link">
        <img class="logo" src="../assets/brasaoTJPA-Logo.png" alt="TJPA logo" />
        <span class="header-text">Lista de Contatos do TJPA</span>
      </a>
    </header>
  </div>
</template>

<script>
export default {
  computed: {
    redirect() {
      const isPublicRoute = this.$route.path === '/' ||
        this.$route.path === '/consulta-contatos' ||
        this.$route.path.startsWith('/contatos/');
      return isPublicRoute ? '/#/consulta-contatos' : '/home';
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.app-header {
  display: flex;
  align-items: center;
  background-color: #1e469a;
  padding: 10px 20px;
}

.header-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}

.header-text {
  font-family: 'Roboto', sans-serif;
  font-weight: bold;
  color: #ffffff;
  font-size: 40px;
}
</style>
